import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField, FormFieldError, FormFieldItem } from '@/components';
import { MarkdownEditor } from '@/components/MarkdownEditor/MarkdownEditor';

import type {
  NewInterviewFormInputs,
  NewInterviewFormStepProps,
} from './common';

export const StepInterviewInstructions = ({
  isActive,
}: NewInterviewFormStepProps) => {
  const { t } = useTranslation(['interview', 'common']);
  const form = useFormContext<NewInterviewFormInputs>();
  const { control } = form;

  if (!isActive) return null;

  return (
    <Flex flexDir="column" gap={4}>
      <Heading fontSize="2xl">
        {t('interview:createNewInterview.directiveText.stepTitle')}
      </Heading>
      <Text>{t('interview:createNewInterview.directiveText.description')}</Text>

      <FormField
        control={control}
        name="informationalText"
        type="custom"
        rules={{
          validate: (value) => {
            if (value && value?.replace('&#x20;', '').trim().length < 20) {
              return t(
                'interview:createNewInterview.directiveText.directiveTextMinLength'
              );
            }
          },
        }}
        render={({ field: { value, ref, onBlur, onChange } }) => {
          return (
            <FormFieldItem>
              <Box
                borderRadius="lg"
                border="1px"
                borderColor="gray.200"
                height="30vh"
                overflowY="auto"
                id="detail"
              >
                <MarkdownEditor
                  placeholder={t(
                    'interview:createNewInterview.directiveText.directiveTextPlaceholder'
                  )}
                  markdown={value ?? ''}
                  onBlur={onBlur}
                  ref={ref}
                  onChange={onChange}
                />
              </Box>
              <FormFieldError />
            </FormFieldItem>
          );
        }}
      />
    </Flex>
  );
};
